import { render, staticRenderFns } from "./ModifyHistoryPanel.vue?vue&type=template&id=99a1352c&scoped=true"
import script from "./ModifyHistoryPanel.vue?vue&type=script&lang=js"
export * from "./ModifyHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./ModifyHistoryPanel.vue?vue&type=style&index=0&id=99a1352c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a1352c",
  null
  
)

export default component.exports